var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',_vm._l((_vm.steps),function(step,index){return _c('div',{key:step.key,staticClass:"step",class:{
      highlight: _vm.currentStep.key === step.key,
    }},[_c('span',{staticClass:"number"},[_vm._v("\n      "+_vm._s((index + 1))+" -\n    ")]),_c('span',{staticClass:"name"},[_vm._v("\n      "+_vm._s(step.name)+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }